import { WarningCircleIcon } from "@phosphor-icons/react";
import { Button, Flex, Text } from "@radix-ui/themes";

import "./widget.css";

export interface WidgetErrorFallbackProps {
  label: string;
  onRetry: () => void;
}

/**
 * Body-only recovery UI when a widget child throws. Red + warning icon so
 * the cell stands out; message is intentionally generic.
 */
export const WidgetErrorFallback = ({
  label,
  onRetry,
}: WidgetErrorFallbackProps) => {
  return (
    <Flex
      // `.workspace-widget__error-fallback` re-enables pointer events, which the
      // widget body drops while the layout is in edit mode. Without it Try
      // again would be unclickable exactly when a widget is most likely to
      // need a reset (mid-rearrange). See `widget.css`.
      className="workspace-widget__error-fallback"
      role="alert"
      direction="column"
      align="center"
      justify="center"
      gap="3"
      p="4"
      height="100%"
      minHeight="0"
    >
      <Flex align="center" gap="2">
        <Text color="red" asChild>
          <WarningCircleIcon size={18} weight="fill" aria-hidden />
        </Text>
        <Text size="2" color="red" align="center">
          There was an error in {label}.
        </Text>
      </Flex>
      <Button
        type="button"
        size="1"
        variant="soft"
        color="red"
        onClick={onRetry}
      >
        Try again
      </Button>
    </Flex>
  );
};
